import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Loader2, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { API, api, errMsg } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { mxn, VERTICAL } from "@/lib/format";
import { ContractText, FeeCallout, MissingFields, SignedBadge } from "@/components/ContractConsent";

const inp = "w-full rounded-xl border border-input bg-white px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-[#FF7A00]";

export default function Contrato() {
  const { token } = useParams();
  const [c, setC] = useState(null);
  const [err, setErr] = useState("");
  const [data, setData] = useState({});
  const [signer, setSigner] = useState("");
  const [accept, setAccept] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get(`/public/contract/${token}`).then(({ data: r }) => setC(r)).catch((e) => setErr(errMsg(e))); }, [token]);
  const missing = (c?.missing || []).filter((m) => !(data[m.key] || "").trim());
  const sign = async (e) => {
    e.preventDefault(); setBusy(true);
    try { const { data: s } = await api.post(`/public/contract/${token}/sign`, { signer_name: signer, accept, data }); setC({ ...c, signed: s }); toast.success(`Contrato firmado · folio ${s.folio}`); }
    catch (er) { toast.error(errMsg(er)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-[#FAF8F5]">
      <header className="ink px-4 py-3"><Link to="/"><Logo dark size={30} tagline={false} /></Link></header>
      <main className="mx-auto max-w-2xl px-4 py-8 space-y-5" data-testid="contract-page">
        {err && <div className="card-warm p-6 text-center text-sm text-red-700" data-testid="contract-error">{err}</div>}
        {!c && !err && <Loader2 className="animate-spin mx-auto text-[#FF7A00]" />}
        {c && <>
          <div><p className="eyebrow">Contrato de servicios · FiinBridge</p><h1 className="font-display font-bold text-2xl sm:text-3xl">Hola {c.client_name?.split(" ")[0]}, revisa y firma tu contrato</h1><p className="text-sm text-[#575757] mt-2">{VERTICAL[c.vertical] || c.vertical}{c.product ? ` · ${c.product}` : ""}{c.amount ? ` · ${mxn(c.amount)}` : ""} · {c.provider} · versión {c.version}</p></div>
          <FeeCallout fee={c.fee} />
          {c.signed ? <SignedBadge signed={c.signed} pdfUrl={`${API}/public/contract/${token}/pdf`} /> : (
            <form onSubmit={sign} className="card-warm p-5 space-y-3" data-testid="contract-sign-form">
              {missing.length > 0 && <><p className="text-xs text-[#575757]">Completa estos datos para tu contrato y tu factura de honorarios:</p><MissingFields missing={c.missing} data={data} onChange={(k, v) => setData((x) => ({ ...x, [k]: v }))} testPrefix="pub" /></>}
              <label className="flex gap-3 items-start text-sm"><input data-testid="pub-contract-accept" type="checkbox" checked={accept} onChange={(e) => setAccept(e.target.checked)} className="mt-1 accent-[#FF7A00]" /><span>He leído y acepto los <b>Términos y Condiciones</b> y el <b>Contrato de Prestación de Servicios</b>, incluidos los honorarios de <b>{c.fee?.short}</b> pagaderos únicamente al éxito.</span></label>
              <input data-testid="pub-contract-signer" className={inp} placeholder="Firma electrónica: escribe tu nombre completo" value={signer} onChange={(e) => setSigner(e.target.value)} required />
              <button data-testid="pub-contract-submit" disabled={busy || !accept || signer.trim().length < 5 || missing.length > 0} className="btn-brand w-full disabled:opacity-50"><ShieldCheck size={16} /> {busy ? "Firmando…" : "Firmar electrónicamente"}</button>
              <p className="text-[11px] text-[#8A8A8A]">Tu aceptación, nombre, fecha, IP y la huella del documento quedan como evidencia de firma electrónica (art. 89 Código de Comercio).</p>
            </form>)}
          <section className="card-warm p-5"><ContractText text={c.text} /></section>
        </>}
      </main>
    </div>
  );
}
